export const activeSessions = {
  name: 'Active Session |||| Active Sessions',
  list: {
    title: 'Active Charging Sessions',
    activeSessions: 'Active Sessions',
    session: 'Session',
    user: 'User',
    site: 'Site',
    charger: 'Charger',
    startTime: 'Start Time',
    type: 'Type',
    status: 'Status',
    actions: 'Actions',
  },
  types: {
    app: 'Mobile App',
    rfid: 'RFID Card',
    admin: 'Admin',
    ocpp: 'OCPP',
    backend_standalone: 'Backend',
    backend_on_behalf: 'On Behalf',
    vendor_api: 'Vendor API',
    kiosk: 'Kiosk',
  },
  fields: {
    id: 'Session ID',
    app_session_id: 'App Session ID',
    transaction_id: 'Transaction ID',
    user_id: 'User ID',
    charger_id: 'Charger ID',
    connector_id: 'Connector ID',
    charger_name: 'Charger Name',
    site_name: 'Site Name',
    status: 'Status',
    start_timestamp: 'Start Time',
    charging_completed_at: 'Charging Completed At',
    duration_seconds: 'Duration',
    energy_delivered: 'Energy Delivered',
    current_power: 'Current Power',
    meter_value: 'Meter Reading',
    estimated_kwh: 'Estimated kWh',
    pre_auth_amount: 'Pre-Auth Amount',
    estimated_cost: 'Estimated Cost',
    final_cost: 'Final Cost',
    last_meter_update: 'Last Update',
    estimated_completion: 'Estimated Completion',
    created_at: 'Created At',
    updated_at: 'Updated At',
  },
  statuses: {
    initiating: 'Initiating',
    charging: 'Charging',
    completing: 'Completing',
    completed: 'Completed',
    failed: 'Failed',
  },
  filters: {
    search: 'Search',
    status: 'Status',
    type: 'Session Type',
    user_id: 'User ID',
    charger_id: 'Charger ID',
    charger: 'Charger',
    site_id: 'Site ID',
    site: 'Site',
    fromDate: 'From Date',
    toDate: 'To Date',
  },
  details: {
    session_info: 'Session Information',
    charging_progress: 'Charging Progress',
    charger_location: 'Charger & Location',
    user_info: 'User Information',
    cost_info: 'Cost Information',
    current_power: 'Current Power',
    duration: 'Duration',
    estimated_cost: 'Estimated Cost',
    energy_progress: 'Energy Progress',
    live: 'LIVE',
    auto_refresh: 'Auto-refreshing every 30s • Last updated',
    still_charging: 'Still charging...',
    target: 'Target',
    delivered: 'delivered',
  },
  actions: {
    refresh: 'Refresh',
    manualStart: 'Manual Start',
    stopSession: 'Stop Session',
    forceComplete: 'Force Complete',
  },
  manualStart: {
    title: 'Manual Start Charging Session',
    sessionMode: 'Session Mode',
    onBehalf: 'On-Behalf (with settlement)',
    standalone: 'Standalone (no settlement)',
    onBehalfDescription: 'Start session on behalf of a user. Costs will be charged to user wallet.',
    standaloneDescription: 'Start standalone session for testing or maintenance. No payment settlement.',
    searchUser: 'Search User',
    searchUserPlaceholder: 'Type to search by name or email...',
    lookupByPhone: 'Look up customer by phone number',
    phonePlaceholder: 'e.g. 12345678',
    lookup: 'Look up',
    phoneNotFound: 'No customer found with this phone number',
    confirmCustomer: 'Confirm with the customer that this is them:',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    site: 'Site',
    sitePlaceholder: 'Select a site...',
    charger: 'Charger',
    chargerPlaceholder: 'Select a charger...',
    chargerPlaceholderNoSite: 'Select a site first',
    connector: 'Connector',
    connectorPlaceholder: 'Select connector...',
    estimatedKwh: 'Estimated kWh',
    estimatedKwhHelp: 'Estimated energy needed for this session',
    createPreAuth: 'Create wallet pre-authorization',
    createPreAuthHelp: 'Hold funds in user wallet before charging starts',
    adminNotes: 'Admin Notes',
    adminNotesPlaceholder: 'Document why this manual session is needed (optional)...',
    adminNotesHelp: 'Optional notes to document the reason for this manual session',
    cancel: 'Cancel',
    startSession: 'Start Session',
    starting: 'Starting...',
    status: 'Status',
    connectorStatus: 'Connector',
    connectors: 'Connectors',
    // Validation errors
    errorSelectSite: 'Please select a site',
    errorSelectCharger: 'Please select a charger',
    errorSelectUser: 'Please select a user for on-behalf mode',
    errorInvalidKwh: 'Estimated kWh must be greater than 0',
    // Notifications
    successOnBehalf: 'Charging session started successfully on behalf of user',
    successStandalone: 'Standalone charging session started successfully',
    errorStartSession: 'Failed to start charging session',
    errorLoadSites: 'Failed to load sites',
    errorLoadChargers: 'Failed to load chargers',
    errorSearchUsers: 'Failed to search users',
    warningNoChargers: 'No available chargers at this site',
  },
  show: {
    title: 'Active Session Details',
    sessionNumber: 'Session',
    chargingProgress: 'Charging Progress',
    sessionInfo: 'Session Information',
    chargerLocation: 'Charger & Location',
    userInfo: 'User Information',
    costInfo: 'Cost Information',
    sessionId: 'Session ID',
    transactionId: 'Transaction ID',
    status: 'Status',
    startTime: 'Start Time',
    stopTime: 'Stop Time',
    lastUpdate: 'Last Update',
    chargerName: 'Charger Name',
    chargerId: 'Charger ID',
    connectorId: 'Connector ID',
    siteName: 'Site Name',
    chargerPower: 'Charger Power',
    connectorType: 'Connector Type',
    userId: 'User ID',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    vehicles: 'Vehicles',
    primary: 'Primary',
    preAuthAmount: 'Pre-Auth Amount',
    currentEstimatedCost: 'Current Estimated Cost',
    finalCost: 'Final Cost',
    notFinalized: 'Not yet finalized',
    meterReading: 'Meter Reading',
    kwh: 'kWh',
    kwhDelivered: 'kWh delivered',
    currentVoltage: 'Current Voltage',
    currentAmps: 'Current (Amps)',
    batterySoc: 'Battery SOC',
    estimatedCompletion: 'Estimated completion',
  },
};